import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./ContactDetails.scss";

const ContactDetails = ({ number, email }) => {
	return (
		<div className="contactDetails">
			{number && number.trim() !== "" && (
				<>
					<FontAwesomeIcon icon={faPhone} className="fa-2x" />
					<h3>{number}</h3>
				</>
			)}
			{email && email.trim() !== "" && (
				<>
					<FontAwesomeIcon icon={faEnvelope} className="fa-2x" />
					<h3>{email}</h3>
				</>
			)}
		</div>
	);
};

export default ContactDetails;
